import React from 'react';
import { Calendar, TrendingUp, Users } from 'lucide-react';
import { t } from 'i18next';

interface ReservationStatsProps {
  stats: {
    total: number;
    confirmed: number;
    canceled: number;
    totalValue: number;
    confirmationRate: number;
  };
}

const ReservationStats: React.FC<ReservationStatsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 reservation-stats">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">{t('reservations.totalBookings', 'Total réservations')}</p>
            <p className="text-2xl font-semibold">{stats.total}</p>
          </div>
          <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
            <Calendar size={20} className="text-blue-600 dark:text-blue-400" />
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">{t('reservations.confirmationRate', 'Taux de confirmation')}</p>
            <p className="text-2xl font-semibold">{stats.confirmationRate}%</p>
          </div>
          <div className="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
            <TrendingUp size={20} className="text-green-600 dark:text-green-400" />
          </div>
        </div>
      </div>
      
      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500 dark:text-gray-400">{t('reservations.totalValue', 'Valeur totale')}</p>
            <p className="text-2xl font-semibold">{stats.totalValue.toFixed(2)}€</p>
          </div>
          <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg">
            <Users size={20} className="text-purple-600 dark:text-purple-400" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationStats;
